import { useState } from "react";
import { useNavigate } from "react-router-dom";
import trackerSvg from "/360Tracker.svg";
import { routeEndpoints } from "../../../../routes/routeEndpoints";

const Navbar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="flex items-center justify-between px-6 lg:px-21 md:px-10 md:py-4 py-2 mx-auto relative w-full overflow-x-hidden md:overflow-visible">
      <div className="flex items-center gap-2">
        <div className="w-15 h-15 text-blue-600">
          <img src={trackerSvg} alt="360 Tracker" className="w-full h-full" />
        </div>
      </div>

      <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 gap-8 text-[#333333] text-base font-normal">
        <a
          href="#how-it-works"
          className="hover:text-blue-600 transition-colors"
        >
          How It Works
        </a>
        <a href="#advantages" className="hover:text-blue-600 transition-colors">
          Advantages
        </a>
        <a href="#faq" className="hover:text-blue-600 transition-colors">
          FAQ
        </a>
      </div>

      <div className="hidden md:flex items-center gap-4 auth-nav-toggle">
        <button
          onClick={() => navigate(routeEndpoints.login)}
          className="text-[#0064E0] px-12 py-3 rounded-xl font-medium text-base cursor-pointer"
        >
          Log in
        </button>
        <button
          onClick={() => navigate(routeEndpoints.signup)}
          className="bg-[#0064E0] text-white px-12 py-3 rounded-xl font-medium text-base cursor-pointer"
        >
          Sign up
        </button>
      </div>

      <div className="md:hidden flex items-center z-50">
        <button
          onClick={toggleMenu}
          className="text-[#333333] focus:outline-none"
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity"
          onClick={toggleMenu}
        ></div>
      )}

      <div
        className={`fixed top-0 right-0 h-full w-full max-w-sm bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } md:hidden flex flex-col`}
      >
        <div className="flex justify-between p-6">
          <div className="flex items-center gap-2">
            <div className="w-15 h-15 text-blue-600">
              <img src={trackerSvg} alt="360 Tracker" />
            </div>
          </div>
          <button
            onClick={toggleMenu}
            className="text-[#333333] focus:outline-none"
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="flex flex-col gap-6 px-6 text-[#333333] text-lg font-medium">
          <a
            href="#how-it-works"
            className="hover:text-blue-600"
            onClick={toggleMenu}
          >
            How It Works
          </a>
          <a
            href="#advantages"
            className="hover:text-blue-600"
            onClick={toggleMenu}
          >
            Advantages
          </a>
          <a href="#faq" className="hover:text-blue-600" onClick={toggleMenu}>
            FAQ
          </a>
        </div>

        <div className="flex flex-col gap-4 px-6 mt-10 auth-nav-toggle">
          <button
            className="text-[#0064E0] w-full py-3 rounded-xl font-medium text-base cursor-pointer"
            onClick={() => {
              toggleMenu();
              navigate(routeEndpoints.login);
            }}
          >
            Log in
          </button>
          <button
            className="bg-[#0064E0] text-white w-full py-3 rounded-xl font-medium text-base cursor-pointer"
            onClick={() => {
              toggleMenu();
              navigate(routeEndpoints.signup);
            }}
          >
            Sign up
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
